const accordions = document.querySelectorAll('.accordion');

if (accordions) {
  accordions.forEach((accordion) => {
    const btn = accordion.querySelector('dt');

    btn.addEventListener('click', () => {
      if (accordion.classList.contains('active')) {
        accordion.classList.remove('active');

        return;
      }

      accordions.forEach((accordion) => {
        accordion.classList.remove('active');
      });

      accordion.classList.add('active');
    });
  });
}
